import React, { useEffect, useState } from "react";
import { FaUserCheck, FaUserSlash } from "react-icons/fa";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RxLapTimer } from "react-icons/rx";
import { Link } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { USER_URL } from "../../constant/api";

function AdminSellers() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await USER_URL.get(`/accounts/admin/companies/`);

        if (response.data?.data) {
          setProducts(response.data.data);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // ✅ Proper filter logic
  const filteredProducts =
    filter === "All"
      ? products
      : products.filter((product) => {
          const status = (product.status || "").toLowerCase();

          if (filter === "Pending") return status === "pending";

          if (filter === "Approved")
            return status === "approved" || status === "confirmed";

          if (filter === "Rejected") return status === "rejected";

          return true;
        });

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-6">Sellers</h2>

      {/* ✅ Filter Tabs */}
      <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5">
        <button
          onClick={() => setFilter("All")}
          className={`flex flex-col items-center gap-1 ${
            filter === "All" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <MdOutlineAccountBalanceWallet className="text-xl" />
            <span className="font-semibold">All</span>
          </div>
          {filter === "All" && <div className="w-full h-1 bg-green-600"></div>}
        </button>

        <button
          onClick={() => setFilter("Pending")}
          className={`flex flex-col items-center gap-1 ${
            filter === "Pending" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <RxLapTimer className="text-xl" />
            <span className="font-medium">Pending</span>
          </div>
          {filter === "Pending" && (
            <div className="w-full h-1 bg-green-600"></div>
          )}
        </button>

        <button
          onClick={() => setFilter("Approved")}
          className={`flex flex-col items-center gap-1 ${
            filter === "Approved" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <FaUserCheck className="text-xl" />
            <span className="font-medium">Approved</span>
          </div>
          {filter === "Approved" && (
            <div className="w-full h-1 bg-green-600"></div>
          )}
        </button>

        <button
          onClick={() => setFilter("Rejected")}
          className={`flex flex-col items-center gap-1 ${
            filter === "Rejected" ? "text-green-600" : "text-gray-400"
          }`}
        >
          <div className="flex items-center gap-2">
            <FaUserSlash className="text-xl" />
            <span className="font-medium">Rejected</span>
          </div>
          {filter === "Rejected" && (
            <div className="w-full h-1 bg-green-600"></div>
          )}
        </button>
      </div>

      {/* ✅ Loading */}
      {loading ? (
        <div className="flex h-96 items-center justify-center">
          <ScaleLoader color="#FFAE00" size={40} />
        </div>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr>
                <th className="text-sm font-bold text-green-500 py-2 px-4">
                  Company Name
                </th>
                <th className="text-sm font-bold text-green-500 py-2 px-4">
                  Location
                </th>
                <th className="text-sm font-bold text-green-500 py-2 px-4">
                  Status
                </th>
                <th className="text-sm font-bold text-green-500 py-2 px-4">
                  Sub Admin
                </th>
                <th className="py-2 px-4"></th>
              </tr>
            </thead>

            <tbody>
              {filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                  <tr key={product.id}>
                    <td className="p-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                        {product.company_name || "-"}
                      </div>
                    </td>

                    <td className="p-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                        {product.location || "-"}
                      </div>
                    </td>

                    <td className="p-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                        {product.status || "-"}
                      </div>
                    </td>

                    <td className="p-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-800">
                        {product.subadmin || "-"}
                      </div>
                    </td>

                    <td className="p-2">
                      <Link
                        to={`/admin/sellers/view/${product.company_id}`}
                        className="rounded-lg border border-green-600 px-4 py-2 text-sm font-medium text-green-600 hover:bg-green-100"
                      >
                        VIEW
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-gray-500">
                    No sellers found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminSellers;
